import { IContent } from '../../content/content.interface';
import { ICTA } from '../cta/cta.interface';
import { TStrapiRichTextBlock } from '../new-sections/strapi-rich-text-block/strapi-rich-text-block.interface';

export type TSubMenu = {
  order: number;
  sub_menu: ESubMenuType;
  label: string;
  description: TStrapiRichTextBlock[];
  ctas: ICTA[];
}

export enum ESubMenuType {
  CONTENT = 'content',
  PRINT_SOLUTIONS = 'printSolutions',
  QUICK_CONNECT_APP_SOLUTIONS = 'quickConnectAppSolutions',
  WHITEBOARD_VIDEOS = 'whiteboardVideos',
  QUICK_BLOG = 'quickBlog',
}

export interface INavLink {
  label: string;
  routerLink?: string;
  subMenu: boolean;
  type?: ESubNav;
  icon?: string;
  path?: string;
  isOpen?: boolean;
  order?: number;
}

export enum ESubNav {
  CONTENT = 'content',
  APP_SOLUTIONS = 'app-solutions',
  PRINT_SOLUTIONS = 'print-solutions-outreach-material',
  WHITEBOARD_VIDEOS = 'whiteboard-videos',
  QUICKBLOG = 'quick-blog-infographics-trends',
}

export interface IContentMenuItem {
  name: string;
  uuid: string;
  slug: string;
  contents: IContent[];
}
